<!-- <div [hidden]="!isSideBarHidden" style="position: relative;">
	<i style="position: fixed;top: 50%;" (click)="isSideBarHidden=false" class="fa fa-arrow-left cursor larger-icon"></i>
  </div>
  <div class="container-fluid">
	<div class="row min-hieght-2500px display_block">
	  <div class="col-md-4" [hidden]="isSideBarHidden">
		<div class="add-section-header" *ngIf="user?.roles=='admin'">
		  <div>
			<i [hidden]="isReadMode" class="fa fa-plus-square cursor larger-icon"
			  (click)="addItem('section', $event, courseId)"><small> Add Section</small></i>
		  </div>
		  <i *ngIf="user?.roles=='admin'"
			[ngClass]="isReadMode?'fa fa-cog cursor larger-icon-read':'fa fa-book cursor larger-icon-read'"
			(click)="isReadMode=!isReadMode"></i>
		</div>
		<div class="list-group" id="items" cdkDropList [cdkDropListData]="sections"
		  (cdkDropListDropped)="onDrop($event,'sections')">
		  <ul>
			<li class="cursor" *ngFor="let section of sections; let sectionIndex = index" cdkDrag [cdkDragData]="section"
			  cdkDropList [cdkDropListData]="section.chapters" (cdkDropListDropped)="onDrop($event,'chapters')">
			  <div class="list-group-item section-list" [ngClass]="{'active-section': activeSectionId==section?._id}">
				<div (click)="activeBreadcrumb(section?.name, section?._id)" data-toggle="collapse"
				  [attr.data-target]="'#sectionCollapse' + sectionIndex">
				  <div *ngIf="section?.isEditing">
					<input [(ngModel)]="section.name" (keydown.enter)="editItem($event, 'section', sectionIndex)">
				  </div>
				  <div class="list-title" *ngIf="!section?.isEditing">
					{{ section?.name }}
					<div style="display: flex">
					  <i *ngIf="!isReadMode && user.roles === 'admin'" class="fa fa-edit cursor"
						(click)="section.isEditing=true"></i>
					  <i *ngIf="!section?.chapters?.length && !isReadMode && user?.roles === 'admin'"
						class="fa fa-trash cursor"
						(click)="confirmDelete($event, 'section', section._id, sectionIndex)"></i>
					  <i *ngIf="!isReadMode && user?.roles === 'admin'" class="fa fa-plus-square cursor"
						(click)="addItem('chapter', $event, section?._id, sectionIndex)"></i>
					  <i *ngIf="section.chapters?.length" class="fa fa-chevron-down cursor"
						[ngbCollapse]="'#sectionCollapse' + sectionIndex"></i>
					</div>
				  </div>
				</div>
				<ul [id]="'sectionCollapse' + sectionIndex" class="collapse"
				  [ngbCollapse]="'#sectionCollapse' + sectionIndex" [class.show]="sectionIndex === 0">
				  <li class="cursor" *ngFor="let chapter of section?.chapters; let chapterIndex = index" cdkDrag
					[cdkDragData]="chapter" cdkDropList [cdkDropListData]="chapter.topics"
					(cdkDropListDropped)="onDrop($event,'topics')">
					<div class="list-group-item chapter-list"
					  [ngClass]="{'active-chapter': activeChapterId==chapter?._id}">
					  <div (click)="activeBreadcrumb(section?.name, section?._id, chapter?.name, chapter?._id)"
						data-toggle="collapse"
						[attr.data-target]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex">
						<div *ngIf="chapter?.isEditing && user?.roles === 'admin'">
						  <input [(ngModel)]="chapter.name"
							(keydown.enter)="editItem($event, 'chapter', sectionIndex, chapterIndex)">
						</div>
						<div class="list-title" *ngIf="!chapter?.isEditing">
						  {{ chapter?.name }}
						  <div style="display: flex">
							<i *ngIf="!isReadMode && user.roles === 'admin'" class="fa fa-edit cursor"
							  (click)="chapter.isEditing=true"></i>
							<i *ngIf="!chapter?.topics?.length && !isReadMode && user?.roles === 'admin'"
							  class="fa fa-trash cursor"
							  (click)="confirmDelete($event, 'chapter', chapter._id, sectionIndex, chapterIndex)"></i>
							<i *ngIf="!isReadMode && user?.roles === 'admin'" class="fa fa-plus-square cursor"
							  (click)="addItem('topic', $event, chapter?._id, sectionIndex, chapterIndex)"></i>
							<i *ngIf="chapter?.topics?.length" class="fa fa-chevron-down cursor"
							  [ngbCollapse]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex"></i>
						  </div>
						</div>
					  </div>
					  <ul [id]="'chapterCollapse' + sectionIndex + '-' + chapterIndex" class="collapse"
						[ngbCollapse]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex"
						[class.show]="sectionIndex === 0 && chapterIndex === 0">
						<li class="cursor"
						  (click)="getAppsByTopic(topic?._id, chapter.topics); activeBreadcrumb(section?.name, section._id, chapter?.name, chapter._id, topic?.name, topic._id)"
						  *ngFor="let topic of chapter.topics; let topicIndex = index" cdkDrag [cdkDragData]="topic">
						  <div class="list-group-item topic-list" [ngClass]="{'active-topic': activeTopicId==topic?._id}">
							<div *ngIf="topic?.isEditing">
							  <input [(ngModel)]="topic.name"
								(keydown.enter)="editItem($event, 'topic', sectionIndex, chapterIndex, topicIndex)">
							</div>
							<div class="list-title" *ngIf="!topic?.isEditing">
							  {{ topic.name }}
							  <div style="display: flex">
								<i *ngIf="user.roles === 'admin'" [hidden]="isReadMode" class="fa fa-edit cursor"
								  (click)="topic.isEditing=true"></i>
								<i *ngIf="user.roles === 'admin'" [hidden]="isReadMode" class="fa fa-trash cursor"
								  (click)="confirmDelete($event, 'topic', topic?._id, sectionIndex, chapterIndex, topicIndex)"></i>
							  </div>
							</div>
						  </div>
						</li>
					  </ul>
					</div>
				  </li>
				</ul>
			  </div>
			</li>
		  </ul>
		</div>
  
	  </div>
  
  
  
	  <div class="col-md-8 video-container" [ngClass]="{'col-12': isSideBarHidden}">
  
		<div id="bc_wrapper">
		  <h3>{{ courseData?.title }}</h3>
		  <span class="section_bc text-capitalize" *ngIf="activeSectionName">&gt;&gt; {{ activeSectionName }}</span>
		  <span class="chapter_bc text-capitalize" *ngIf="activeChapterName">&gt;&gt; {{ activeChapterName }}</span>
		  <span class="topic_bc blue_c text-capitalize" *ngIf="activeTopicName">&gt;&gt; {{ activeTopicName }}</span>
		</div>
		<app-lms-new-content [topics]="selectedTopics" (refreshData)="getAppsByTopic(topicId,selectedTopics)"
		  [appsByTopic]="appsByTopic" [isReadMode]="isReadMode" [topicId]="topicId"
		  [courseId]="courseId"></app-lms-new-content>
	  </div>
  
	</div>
  </div>
  
  ---------- Teacher for Time Update  Modal  ---------------
  <div>
	<ng-template #myModal let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Teach Time</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<form>
		  <div class="form-group">
			<label>Teaching Time</label>
			<input type="datetime-local" class="form-control" [(ngModel)]="teaching_time"
			  [ngModelOptions]="{standalone: true}">
		  </div>
		</form>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
	  </div>
	</ng-template>
  </div>
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div> -->


  <div class="courses-lms">
	<div class="container">
		<div class="row">
			<div class="col-md-5">
				<div class="courses-lms-left">
					<div class="title-wrapper">
						<div class="dropdown">
							<button class="btn btn-secondary dropdown-toggle lms-courses-drpdown" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							  Course 3 of 10
							</button>
							<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
							  <a class="dropdown-item" href="#">Course 1</a>
							  <a class="dropdown-item" href="#">Course 2</a>
							  <a class="dropdown-item" href="#">Course 3</a>
							</div>
						</div>
						
						<h1 class="title">Research Methodology 1</h1>

						<div class="progress-wrapper">
							<div class="progress-info">
								<div class="progress-completion">
									<p>100% Complete</p>
								</div>
								<div class="progress-time">
									<p>0m left</p>
								</div>
							</div>
							<div class="progress">
								<div class="progress-bar bg-secondary" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
							</div>
						</div>
					</div>
					<div class="mod-overview">
						<h4 class="title">MODULES OVERVIEW</h4>
					</div>
				</div>
			</div>
			<div class="col-md-7">
				<div class="card-dropdown">
					<div class="drpdown-wrap">
						<div id="accordionExample" class="accordion">

							<!-- Accordion item 1 -->
							<div class="card bg-white">
							  <div id="headingOne" class="card-header border-0">
								<h2 class="mb-0">
								  <div data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
									aria-controls="collapseOne"
									class="custom-dropdown collapsible-link"><p class="mod-num">Module 1</p>
									<h2>Welcome Message</h2>
									<div class="stage-info">
										<p class="subb">Submissions: none</p>
										<p class="stage-info">Completed</p>
									</div>
								</div>
								</h2>
							  </div>
							  <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordionExample" class="collapse show">
								<div class="card-body">
								  <p class="card-infoo m-0">Indroduction to the course</p>
								</div>
							  </div>
							</div><!-- End -->
					
							<!-- Accordion item 2 -->
							<div class="card bg-white">
								<div id="headingTwo" class="card-header border-0">
								  <h2 class="mb-0">
									<div data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
									  aria-controls="collapseTwo"
									  class="custom-dropdown collapsible-link"><p class="mod-num">Module 1</p>
									  <h2>Welcome Message</h2>
									  <div class="stage-info">
										  <p class="subb">Submissions: none</p>
										  <p class="stage-info">Completed</p>
									  </div>
								  </div>
								  </h2>
								</div>
								<div id="collapseTwo" aria-labelledby="headingOne" data-parent="#accordionExample" class="collapse">
								  <div class="card-body">
									<p class="card-infoo m-0">Indroduction to the course</p>
								  </div>
								</div>
							  </div><!-- End -->
					
							<!-- Accordion item 3 -->
							<div class="card bg-white">
								<div id="headingThree" class="card-header border-0">
								  <h2 class="mb-0">
									<div data-toggle="collapse" data-target="#collapsethree" aria-expanded="false"
									  aria-controls="collapseThree"
									  class="custom-dropdown collapsible-link"><p class="mod-num">Module 1</p>
									  <h2>Welcome Message</h2>
									  <div class="stage-info">
										  <p class="subb">Submissions: none</p>
										  <p class="stage-info">Completed</p>
									  </div>
								  </div>
								  </h2>
								</div>
								<div id="collapsethree" aria-labelledby="headingOne" data-parent="#accordionExample" class="collapse">
								  <div class="card-body">
									<p class="card-infoo m-0">Indroduction to the course</p>
								  </div>
								</div>
							  </div><!-- End -->
					
						  </div><!-- End -->
				</div>
			</div>
		</div>
	</div>
  </div>